export const LOADING_JOB = "LOADING_JOB";
export const SUCCESS_JOB = "SUCCESS_JOB";

export const SET_SELECTED_JOB = "SET_SELECTED_JOB";
export const SET_WORK_STATUS = "SET_WORK_STATUS";
export const SET_COMPANY = "SET_COMPANY";